const EMPTY_CATALOG = null
let _catalogCache = { ref: undefined, result: EMPTY_CATALOG }

export function selectAHCatalogProducts(state) {
  // API returns { meta, catalog: [...] } — catalog is a flat array of all products
  const products = state.catalog?.catalog ?? null
  if (!products) return EMPTY_CATALOG

  // Return cached result if the catalog array hasn't changed
  if (products === _catalogCache.ref) return _catalogCache.result

  // Filter to AH products only (catalog may contain multiple supermarkets)
  const result = products.filter(p => p.supermarket === 'ah')
  _catalogCache = { ref: products, result }
  return result
}
